import request from '@/utils/request'
const BASE_URL = '/Attendance'

//考勤
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  //获取班级学生
  getStudentsV2(data) {
    return request({
      url: BASE_URL + '/GetStudentsV2',
      method: 'get',
      params: { ...data }
    })
  },
  //获取年级统计
  getStat1(data) {
    return request({
      url: BASE_URL + '/GetStat1',
      method: 'get',
      params: {
        attendanceDate: data.date,
        sectionId: data.sectionId,
      }
    })
  },
  //获取班级统计
  getStat2(data) {
    return request({
      url: BASE_URL + '/GetStat2',
      method: 'get',
      params: {
        attendanceDate: data.date,
        sectionId: data.sectionId,
        gradeId: data.gradeId
      }
    })
  },
  //获取年级统计v1
  getStat1V2(data) {
    return request({
      url: BASE_URL + '/GetStat1V2',
      method: 'get',
      params: {
        attendanceDate: data.date,
        sectionNumber: data.section,
      }
    })
  },
  //获取年级统计v2
  getStat2V2(data) {
    return request({
      url: BASE_URL + '/GetStat2V2',
      method: 'get',
      params: {
        attendanceDate: data.date,
        sectionNumber: data.section,
        gradeId: data.gradeId
      }
    })
  },
  getIndexStat(time = null) {
    return request({
      url: BASE_URL + '/GetIndexStat',
      method: 'get',
      params: {
        time
      }
    })
  },
  getLogList(params) {
    return request({
      url: BASE_URL + '/GetLogList',
      method: 'get',
      params
    })
  },
  getLogListV2(params) {
    return request({
      url: BASE_URL + '/GetLogListV2',
      method: 'get',
      params
    })
  },
}